import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useGamificationFx } from '@/contexts/GamificationFxContext';

export function AchievementToastHost() {
  const fx = useGamificationFx();
  const { t } = useTranslation();
  const lastSeenRef = useRef<string | null>(null);

  useEffect(() => {
    if (fx.showingAchievement && fx.showingAchievement.code !== lastSeenRef.current) {
      lastSeenRef.current = fx.showingAchievement.code;
      const a = fx.showingAchievement;
      toast.success(t('gamification.achievementUnlocked'), {
        description: `${a.name} · +${a.xpReward} XP`,
        duration: 3000,
      });
    }
    if (!fx.showingAchievement) lastSeenRef.current = null;
  }, [fx.showingAchievement, t]);

  return null;
}
